export default {
  dashboard: "Dashboard",
  users: "Users",
  areaIncomeRange: "Area Income Range",
  clients: "Clients",
  invoices: "Invoices",
};
